// Per-client, per-environment provisioning access.
//
// All environments share the `provisioning-anep` realm, so a user's access is
// scoped by Keycloak subgroups under /Clients/{uuid}:
//   /Clients/{uuid}/{env}     grants access on that environment
//   /Clients/{uuid}/members   roster marker, grants nothing
//   /Clients/{uuid}           legacy flat group, grants every env until the
//                             user is migrated to subgroups

export interface ClientUserAccess {
  id: string;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  /** Keycloak account switch. False means suspended on every environment. */
  enabled: boolean;
  roles: string[];
  /** Keycloak creation timestamp, milliseconds since the epoch. */
  createdTimestamp?: number;
  /** Whether this user reaches provisioning for this client on this env. */
  hasAccess: boolean;
  /** True while access still comes from the pre-env flat group. */
  legacyAccess: boolean;
  /** Environments this user reaches for this client (empty when legacy). */
  envs: string[];
}

export interface ClientUserAccessList {
  client_id: string;
  /** Environment this backend serves: "dev", "staging" or "prod". */
  env: string;
  users: ClientUserAccess[];
  total: number;
}

export interface ClientAccessMutationResult {
  client_id: string;
  user_id: string;
  env: string;
  hasAccess: boolean;
}

/** Display name for a user row, falling back to the username. */
export const clientUserDisplayName = (user: ClientUserAccess): string =>
  [user.firstName, user.lastName].filter(Boolean).join(' ') || user.username;
